import { render, staticRenderFns } from "./masterpaketislem.vue?vue&type=template&id=89acb3b4"
import script from "./masterpaketislem.vue?vue&type=script&lang=js"
export * from "./masterpaketislem.vue?vue&type=script&lang=js"
import style0 from "./masterpaketislem.vue?vue&type=style&index=0&id=89acb3b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports